import { type Option } from "api/common/types/common.types";
import { withForm } from "components/Forms/AppForm";

import { ecrFormDefaultValues } from "./ecrFormDefaultValues";

const EcrTechnicalDecisionsSection = withForm({
  defaultValues: ecrFormDefaultValues,
  props: {
    tdOptions: [] as Option[],
  },
  render: function Render({ form, tdOptions }) {
    return (
      <form.FormSection title="Technical Decisions">
        <form.AppField name="technicalDecisions">
          {(field) => (
            <field.MultiAutocompleteSelect
              label="Technical Decisions"
              options={tdOptions}
            />
          )}
        </form.AppField>
      </form.FormSection>
    );
  },
});

export default EcrTechnicalDecisionsSection;
